import React from "react";
import { Row, Col } from "react-bootstrap";
import ProviderCard from "./cards/ProviderCard";
import PatientCard from "./cards/PatientCard";
import EncounterCard from "./cards/EncounterCard";
import styles from "./Inbox.module.css"; // Optional custom styles

/**
 * InfoBar component displays Provider, Patient, and Encounter summary cards.
 * Props:
 * - fhirClient: Initialized FHIR client
 * - contextPatient: Patient resource
 * - contextProvider: Practitioner resource
 * - encounterData: Encounter resource
 * - layout: "vertical" (default) or "horizontal"
 */
function InfoBar({
  fhirClient,
  contextPatient,
  providerData,
  encounterData,
  layout = "horizontal"
}) {

  //console.log("InfoBar props:");
  //console.log(contextPatient);
  //console.log(encounterData);
  //console.log(providerData);
  
  
  return (
    <Row className={layout === "horizontal" ? "g-3" : ""}>
      <Col md={layout === "horizontal" ? 4 : 12}>
        <ProviderCard
          title="From: Provider"
          showSearch={false}
          inContext={false}
          fhirClient={fhirClient}
          providerData={providerData}
        />
      </Col>

      <Col md={layout === "horizontal" ? 4 : 12}>
        <PatientCard
          title="Re: Patient"
          inContext={false}
          fhirClient={fhirClient}
          patientData={contextPatient}
        />
      </Col>

      <Col md={layout === "horizontal" ? 4 : 12}>
        <EncounterCard
          title="Re: Encounter"
          inContext={false}
          fhirClient={fhirClient}
          encounterData={encounterData}
          enableSearch={false}

        />
      </Col>
    </Row>
  );
}

export default InfoBar;